// simple dayjs importer to allow DRYer usage of dayjs
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);
dayjs().format();

export const getDayJs = () => dayjs;
